import { render } from "./HermesCustomersList.vue?vue&type=template&id=84f94fba&scoped=true"
import script from "./HermesCustomersList.vue?vue&type=script&lang=js"
export * from "./HermesCustomersList.vue?vue&type=script&lang=js"

import "./HermesCustomersList.vue?vue&type=style&index=0&id=84f94fba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84f94fba"]])

export default __exports__